import React from 'react';
import Proptypes from 'prop-types';
import Plot from "react-plotly.js";
import Plotly from 'plotly.js/dist/plotly';
import _ from 'lodash';

/* React component which renders graphs */
class SaxsSimplePlotter extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            curves: [],
            layout: {
                title: '',
                xaxis: { title: 'frame' },
                autosize: true,
                legend: {
                    //orientation: 'h'
                }
            },
            config: {
                //responsive: true,
                //autosizable: true
            }
        }

        this.onAutoSize = this.onAutoSize.bind(this);
    }

    render() {
        //let dataSeries = _.cloneDeep(this.props.dataSeries);  // this is not CSV data
        let dataSeries = this.props.dataSeries;
        if (dataSeries) {

            // create the plotting object
            let requiredCurves = [];
            dataSeries.forEach(dataSerie => {
                requiredCurves.push({
                    x: dataSerie.values.x,
                    y: dataSerie.values.y,
                    type: 'scatter',
                    mode: 'lines',
                    name: dataSerie.label,

                    // marker: { 
                    //     color: dataSerie.color,
                    // },

                    line: {
                        color: dataSerie.isAStdDevDataSerie === true ? 'rgba(255,255,255,0)' : dataSerie.color,
                    },

                    connectgaps: false,
                    fill: dataSerie.isAStdDevDataSerie === true ? "tozeroy" : 'none',
                    fillcolor: dataSerie.isAStdDevDataSerie === true ? "rgba(255,0,255,0.2)" : null,
                    showlegend: dataSerie.isAStdDevDataSerie === true ? false : true,
                    hoverinfo: dataSerie.isAStdDevDataSerie === true ? 'none' : 'all',
                });

            });

            if (!_.isEqual(requiredCurves, this.state.curves)) {
                this.setState({ curves: requiredCurves });
                return null;
            } else {
                return <Plot
                    divId={this.props.divId}
                    data={this.state.curves}
                    layout={this.state.layout}
                    config={this.state.config}
                    useResizeHandler={true}
                    onAutoSize={this.onAutoSize}
                    onClick={this.props.onPlotPointClicked}
                    onRelayout={this.props.onPlotRelayout}
                    onInitialized={this.props.onPlotInitialized}
                />
            }
        }

        return null;
    }

    /**
     * Callback function triggered when the plot is loaded (at least) provided autosize=true
     */
    onAutoSize() {
        let graphElement = document.getElementById(this.props.divId)
        if (graphElement) {
            this.height = graphElement.parentNode.offsetHeight;
            this.width = graphElement.parentNode.offsetWidth - 30; // remove the padding of the parent
            Plotly.relayout(this.props.divId, {
                width: this.width,
                height: 400
            })
        }
    }
}

export default SaxsSimplePlotter;

SaxsSimplePlotter.proptypes = {
    /* the data series to be plotted */
    dataSeries: Proptypes.object,
    /* a unique name identifying the div where the plot is. */
    divId: Proptypes.string.isRequired,
    /* callback function triggered when the user clicks on the plot */
    onPlotPointClicked: Proptypes.func
}



// WEBPACK FOOTER //
// ./src/components/saxs/SaxsSimplePlotter.js